import React, { createRef, PureComponent } from 'react';
import { Button, Select, notification, Form, Input, Row, Col } from 'antd';
import IPut from '../IPut';
import { BLANK_IP, IPStack } from '../Device/Simulator/Ethernet';

const { Option } = Select;

export default class IPConfigPage extends PureComponent {
    constructor(props) {
      super(props);
  
      this.formRef = createRef();
  
      ['onReset', 'onSubmit', 'onFail', 'onChange'].forEach(func => this[func] = this[func].bind(this));

      this.state = {
        version: 0,
        ipConfig: null,
      }
    }
  
    onReset() {
      this.formRef.current.resetFields();
    }

    componentDidMount() {
      const { ipConfig } = this.props.device.toJSON();
      this.setState({
        ipConfig
      })
    }
  
    async onSubmit(ipConfig) {
      const { device, onSubmit } = this.props;
  
      switch(ipConfig.ipMode) {
        case 'DHCP':
          try {
            ipConfig = await device.DHCP_discover();
          }
          catch(e) {
            notification.error({
              message: 'DHCP错误',
              description: e.message
            });
            return;
          }
  
          this.formRef.current.setFieldsValue(ipConfig);
          break;
        case 'STATIC':
          // IP地址为空
          if(ipConfig.ipAddress === BLANK_IP) {
            notification.error({
              message: '配置错误',
              description: '请配置设备IP地址'
            });

            return;
          }

          // 子网掩码地址为空
          if(ipConfig.subnetMask === BLANK_IP) {
            notification.error({
              message: '配置错误',
              description: '请配置设备子网掩码'
            });

            return;
          };

          // 通过ARP广播判别IP是否已经存在
          if(ipConfig.ipAddress !== device.ipConfig.ipAddress) {
            let isIPExist = false;
            try {
              isIPExist = await device.networkCard.ARP_lookup(ipConfig.ipAddress);  
            }
            catch(e) {}

            if(isIPExist) {
              notification.error({
                message: '配置错误',
                description: 'IP地址配置与网络中设备冲突'
              });

              return;
            }  
          }

          device.updateIPConfig(ipConfig);

          break;
        case 'PPPOE':
          try {
            device.updateIPConfig(ipConfig);
            ipConfig = await device.PPPOE_connect();

            console.log(ipConfig);
            this.formRef.current.setFieldsValue(ipConfig);
          }
          catch(e) {
            notification.error({
              message: 'PPPoE客户端错误',
              description: e.message
            });
            return;
          }
          break;
        default:
          throw new Error(`未实现的IP模式${ipConfig.ipMode}`);
      }
  
      this.setState({
        version: 0
      }, () => {
        notification.success({
          message: '配置已保存',
        });

        if(onSubmit) {
          onSubmit();
        }
      });
    }

    onFail(errorInfo) {
      notification.error({
        message: '错误',
        description: '表单填写出错，请按照提示信息进行检查！'
      });
    }
  
    onChange(changedValues, allValues) {
      let { version, ipConfig } = this.state;
      version++;
  
      const nextState = {
        version, 
        ipConfig: {
          ...ipConfig,
          ...changedValues
        }
      };
  
      // 刷新UI
      if(changedValues.ipMode) {
        const defaultIPConfig = IPStack.getDefaultIPConfig();
        nextState.ipConfig = {
          ...defaultIPConfig,
          ...changedValues
        };

        this.formRef.current.setFieldsValue(nextState.ipConfig);
      }
  
      this.setState(nextState);
    }
  
    render() {
      const { formRef } = this;
      const { mode, style, layoutMode = "single" } = this.props;

      const { version, ipConfig } = this.state;
      if(!ipConfig) {
        return null;
      }

      const { ipMode = ipConfig.ipMode } = ipConfig;

      if(layoutMode === 'two') {
        return (
          <Form
            style={style}
            ref={formRef}
            name="IPConfig"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 12 }}
            initialValues={ipConfig}
            size="large"
            onFinish={this.onSubmit}
            onFinishFailed={this.onFail}
            onValuesChange={this.onChange}
          >
          <Row>
            <Col span={12}>
              <Form.Item
                label="工作模式"
                name="ipMode"
                rules={[{ required: true }]}
              >
                <Select>
                  <Option value="DHCP">DHCP</Option>
                  <Option value="STATIC">静态地址</Option>
                  {mode !== 'router' ? <Option value="PPPOE">PPPoE</Option> : null }
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>

            </Col>
          </Row>

          {ipMode === 'PPPOE' ? (
          <Row>
            <Col span={12}>
              <Form.Item
                label="用户名"
                name="pppoe_username"
                rules={[{ required: true, message: 'PPPoE模式下用户名是必填项' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="密码"
                name="pppoe_password"
                rules={[{ required: true, message: 'PPPoE模式下密码是必填项' }]}
              >
                <Input type="password" />
              </Form.Item>
            </Col>
          </Row>
          ): null}
          <Row>
            <Col span={12}>
              <Form.Item
                label="IP地址"
                name="ipAddress"
                rules={[{ required: true }]}
              >
                <IPut disabled={ipMode !== 'STATIC'} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="子网掩码"
                name="subnetMask"
                rules={[{ required: true }]}
              >
                <IPut disabled={ipMode !== 'STATIC'} />
              </Form.Item>
            </Col>
          </Row>
          {
            mode !== 'router' ? (
              <Row>
                <Col span={12}>
                  <Form.Item
                    label="网关"
                    name="gateway"
                    rules={[{ required: true }]}
                  >
                    <IPut disabled={ipMode !== 'STATIC'} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="DNS服务器"
                    name="dns"
                    rules={[{ required: true }]}
                  >
                    <IPut disabled={ipMode !== 'STATIC'} />
                  </Form.Item>
                </Col>
              </Row>
            ) : null
          }
          <Form.Item wrapperCol={{ offset: 14, span: 10 }}>
            <Button type={ version ? "danger": "primary"} htmlType="submit">
              应用
            </Button>
            <Button style={{marginLeft: 10}} htmlType="button" onClick={this.onReset}>
              重置
            </Button>
          </Form.Item>
        </Form>

        );
      }

      return (
        <Form
          style={style}
          ref={formRef}
          name="IPConfig"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 12 }}
          initialValues={ipConfig}
          size="large"
          onFinish={this.onSubmit}
          onFinishFailed={this.onFail}
          onValuesChange={this.onChange}
        >
            <Form.Item
              label="工作模式"
              name="ipMode"
              rules={[{ required: true }]}
            >
              <Select>
                <Option value="DHCP">DHCP</Option>
                <Option value="STATIC">静态地址</Option>
                {mode !== 'router' ? <Option value="PPPOE">PPPoE</Option> : null }
              </Select>
            </Form.Item>
        <Row>
          <Col span={12}>

          </Col>
          <Col span={12}>

          </Col>
        </Row>

        {ipMode === 'PPPOE' ? (
          <>
            <Form.Item
              label="用户名"
              name="pppoe_username"
              rules={[{ required: true, message: 'PPPoE模式下用户名是必填项' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="密码"
              name="pppoe_password"
              rules={[{ required: true, message: 'PPPoE模式下密码是必填项' }]}
            >
              <Input type="password" />
            </Form.Item>
          </>
        ): null}
        <Form.Item
          label="IP地址"
          name="ipAddress"
          rules={[{ required: true }]}
        >
          <IPut disabled={ipMode !== 'STATIC'} />
        </Form.Item>
        <Form.Item
          label="子网掩码"
          name="subnetMask"
          rules={[{ required: true }]}
        >
          <IPut disabled={ipMode !== 'STATIC'} />
        </Form.Item>
        {
          mode !== 'router' ? (
            <>
                <Form.Item
                  label="网关"
                  name="gateway"
                  rules={[{ required: true }]}
                >
                  <IPut disabled={ipMode !== 'STATIC'} />
                </Form.Item>
                <Form.Item
                  label="DNS服务器"
                  name="dns"
                  rules={[{ required: true }]}
                >
                  <IPut disabled={ipMode !== 'STATIC'} />
                </Form.Item>
            </>
          ) : null
        }
        <Form.Item wrapperCol={{ offset: 14, span: 10 }}>
          <Button type={ version ? "danger": "primary"} htmlType="submit">
            确定
          </Button>
          <Button style={{marginLeft: 10}} htmlType="button" onClick={this.onReset}>
            重置
          </Button>
        </Form.Item>
      </Form>
      )
    }
}
  